import { useCallback, useEffect, useState } from "react";
import {
  clearInstallPrompt,
  getInstallPrompt,
  subscribeInstallPrompt,
} from "../pwa/installPrompt";

const estaInstalada = () =>
  window.matchMedia?.("(display-mode: standalone)").matches ||
  // iOS no expone display-mode, usa una propiedad propia
  window.navigator.standalone === true;

// Safari en iOS no implementa beforeinstallprompt: ahí la instalación es manual
// desde el menú Compartir, así que hay que explicarla en vez de ofrecer un botón
// que no haría nada.
const esIOS = () => {
  const ua = window.navigator.userAgent;
  if (/iphone|ipad|ipod/i.test(ua)) return true;
  // iPadOS 13+ se anuncia como Mac; se distingue por el soporte táctil
  return window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1;
};

export const usePwaInstall = () => {
  const [prompt, setPrompt] = useState(getInstallPrompt);
  const [instalada, setInstalada] = useState(estaInstalada);

  useEffect(() => subscribeInstallPrompt(setPrompt), []);

  useEffect(() => {
    const mq = window.matchMedia("(display-mode: standalone)");
    const alCambiar = () => setInstalada(estaInstalada());

    mq.addEventListener?.("change", alCambiar);
    window.addEventListener("appinstalled", alCambiar);
    return () => {
      mq.removeEventListener?.("change", alCambiar);
      window.removeEventListener("appinstalled", alCambiar);
    };
  }, []);

  const install = useCallback(async () => {
    if (!prompt) return null;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    clearInstallPrompt();
    return outcome;
  }, [prompt]);

  return {
    instalada,
    // Chrome, Edge, Samsung Internet, Android: hay prompt nativo disponible
    puedeInstalar: Boolean(prompt) && !instalada,
    // iOS: hay que enseñar los pasos manuales
    requierePasosManuales: !instalada && !prompt && esIOS(),
    install,
  };
};
